function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { FormControl, Typography } from '@applyboard/ui-components';
import { Chip, ChipGroup, Flex, MultiCombobox } from '@applyboard/crystal-ui';
import { SearchOutlineIcon } from '@applyboard/ui-icons';
import ErrorMessage from "../../../CEF/Common/ErrorMessage";
export var FieldsOfEducationField = function FieldsOfEducationField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    helperText = _ref.helperText;
  var optionIdToLabelMap = Object.fromEntries(options.map(function (category) {
    if (category.children.length === 0) {
      return [[category.name, category.label]];
    }
    return category.children.map(function (subcategory) {
      return [subcategory.name, subcategory.label];
    });
  }).flat());
  var allOptions = Object.entries(optionIdToLabelMap).sort(function (_ref2, _ref3) {
    var _ref4 = _slicedToArray(_ref2, 2),
      labelA = _ref4[1];
    var _ref5 = _slicedToArray(_ref3, 2),
      labelB = _ref5[1];
    return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
  }).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      id = _ref7[0],
      label = _ref7[1];
    return /*#__PURE__*/React.createElement(MultiCombobox.Option, {
      key: id,
      label: label,
      value: id
    });
  });
  var chips = value.map(function (id) {
    var label = optionIdToLabelMap[id];
    return [id, label];
  }).sort(function (_ref8, _ref9) {
    var _ref10 = _slicedToArray(_ref8, 2),
      labelA = _ref10[1];
    var _ref11 = _slicedToArray(_ref9, 2),
      labelB = _ref11[1];
    return labelA.toLocaleLowerCase().localeCompare(labelB.toLocaleLowerCase());
  }).map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      id = _ref13[0],
      label = _ref13[1];
    return /*#__PURE__*/React.createElement(Chip, {
      key: id,
      onDelete: function onDelete() {
        return onChange(value.filter(function (categoryId) {
          return categoryId !== id;
        }));
      }
    }, label);
  });
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    style: {
      width: '100%',
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    component: "legend"
  }, label), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/React.createElement(MultiCombobox, {
    filterOption: function filterOption(option, query) {
      return option.label.toLocaleLowerCase().includes(query.toLocaleLowerCase());
    },
    label: "Search programs",
    leadIcon: SearchOutlineIcon,
    onChange: onChange,
    placeholderVariant: "indicator",
    value: value
  }, allOptions), /*#__PURE__*/React.createElement(ChipGroup, null, chips))), helperText && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: helperText
  }));
};